// ======================================================================
// File Name       : LiveReservedEditContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, isInvalid, getFormValues } from 'redux-form';
import { Form, FormControl, Col, Button } from 'react-bootstrap';
import Header from '../../components/Header';
import LiveReservedRegisterInfo from '../../components/usageSettingLive/LiveReservedRegisterInfo';
import LiveRegisterUserList from '../../components/usageSettingLive/LiveRegisterUserList';
import LiveUserAttributeEdit from '../../components/usageSettingLive/LiveUserAttributeEdit';
import * as UsageSettingLiveAction from '../../actions/UsageSettingLiveActions';
import { SERVICE_USER_TYPE } from '../../constants/ServiceConstant';
import * as ModalIds from '../../constants/ModalIds';
import * as ModalAction from '../../actions/ModalAction';
import ModalConductor from '../../components/modal/ModalConductor';
import { canAccessRoute } from '../../utils/AuthedUtils';
import * as FunctionConstants from '../../constants/FunctionConstants';
import * as GroupAction from '../../actions/GroupAction';
import { LIVE_FORMAT_NUM } from '../../constants/UsageSettingLiveConstant';
import { MESSAGE_TYPE } from '../../constants/index';
import * as MessageTemplate from '../../constants/MessageTemplate';
import MessageView from '../../components/MessageView';

class LiveReservedEditContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      singleSelect: true,
      shouldAddSearchInfo: false,
      userType: null,
      expanded: false,
      headerName: 'ライブ開催者を選択してください',
    };
    this.showSelectOrganizerDialog = this.showSelectOrganizerDialog.bind(this);
    this.showSelectInviteesDialog = this.showSelectInviteesDialog.bind(this);
    this.addUsersToList = this.addUsersToList.bind(this);
    this.removeUserFromList = this.removeUserFromList.bind(this);
    this.registerLiveReservation = this.registerLiveReservation.bind(this);
    this.onTitleClick = this.onTitleClick.bind(this);
    this.getLiveReservedDetail = this.getLiveReservedDetail.bind(this);
    this.goBack = this.goBack.bind(this);
    this.removeAllUserFromList = this.removeAllUserFromList.bind(this);
  }

  componentWillMount() {
    const { match } = this.props;
    if (!match.params || !match.params.id) {
      this.props.history.goBack();
    }
    const canAccess = canAccessRoute(FunctionConstants.LIVE_RESERVED_EDIT);
    if (!canAccess) {
      this.props.history.goBack();
    }
    this.props.dispatch(GroupAction.removeGroupList());
    this.props.dispatch(UsageSettingLiveAction.resetEdittingUsers());
    this.props.dispatch(UsageSettingLiveAction.initDataForRegisterEdit()).then(() => {
      this.getLiveReservedDetail(match.params.id);
    });
  }

  getLiveReservedDetail(liveSecernId, canAccess) {
    const param = {};
    param.searchInfo = { liveList: [liveSecernId], includeCompletedLive: 1 };
    this.setState(
      {
        canAccess,
      },
      () => {
        this.props.dispatch(UsageSettingLiveAction.getLiveReservedDetail(param));
      },
    );
  }

  componentWillUnmount() {
    this.props.dispatch(UsageSettingLiveAction.resetEdittingUsers());
  }

  hideModal() {
    this.props.dispatch(ModalAction.hideModal());
  }

  showSelectOrganizerDialog() {
    this.setState(
      {
        singleSelect: true,
        shouldAddSearchInfo: true,
        userType: null,
        headerName: 'ライブ開催者を選択してください',
      },
      () => {
        const { liveAuthorityIdList, dispatch } = this.props;
        if (!liveAuthorityIdList || !liveAuthorityIdList.length) {
          this.props.dispatch(UsageSettingLiveAction.getLiveAuthorityList()).then(() => {
            this.props.dispatch(ModalAction.openModal(ModalIds.SELECT_USER_DIALOG));
          });
        } else {
          this.props.dispatch(ModalAction.openModal(ModalIds.SELECT_USER_DIALOG));
        }
      },
    );
  }

  showSelectInviteesDialog() {
    this.setState(
      {
        singleSelect: false,
        shouldAddSearchInfo: false,
        userType: SERVICE_USER_TYPE.SERVICE,
        headerName: 'ライブに招待するユーザーを選択してください',
      },
      () => {
        this.props.dispatch(ModalAction.openModal(ModalIds.SELECT_USER_DIALOG));
      },
    );
  }

  addUsersToList(userList) {
    const { formValues } = this.props;
    this.props.change('storedEdittingUserList', userList.storedEdittingUserList);
    this.props.dispatch(UsageSettingLiveAction.addUsersToList(userList.userListToAdd));
  }

  removeUserFromList(userSecernId) {
    const { formValues } = this.props;
    if (
      formValues &&
      formValues.storedEdittingUserList &&
      formValues.storedEdittingUserList[userSecernId]
    ) {
      const newStoredEdittingUserList = { ...formValues.storedEdittingUserList };
      delete newStoredEdittingUserList[userSecernId];
      this.props.change('edittingUserList', newStoredEdittingUserList);
      this.props.change('storedEdittingUserList', newStoredEdittingUserList);
    }
  }

  registerLiveReservation() {
    const { invalid } = this.props;
    if (invalid) {
      return;
    }
    this.props.dispatch(ModalAction.openModal(ModalIds.LIVE_REGISTER_CONFIRM));
  }

  onTitleClick() {
    this.setState(prevState => ({
      expanded: !prevState.expanded,
    }));
  }

  goBack() {
    this.props.history.goBack();
  }

  removeAllUserFromList() {
    const { dispatch, change } = this.props;
    change('edittingUserList', {});
    change('storedEdittingUserList', {});
  }

  render() {
    const {
      formValues,
      storedUserList,
      edittingUsers,
      liveAuthorityIdList,
      liveReservationTime,
      durationLiveDetail,
      onewayLiveEntryLimit,
      twowayLiveEntryLimit,
    } = this.props;
    const additionalSearchInfo =
      liveAuthorityIdList && liveAuthorityIdList.length
        ? { managementAuthorityList: [...liveAuthorityIdList, ""] } //STEP11.1.1 add emty string to get new admin
        : {};
    let liveFormat = '';
    formValues && (liveFormat = formValues.liveFormat);
    // Step11.2.0 TAS-17811 START
    const messageWarning = { // step 11.2.0
      messageVisible: true,
      messageType: MESSAGE_TYPE.warning,
      messageHeader: '',
      messageContent: [MessageTemplate.MSG_WARNING_LIVE],
    };
    // Step11.2.0 TAS-17811 END

    return (
      <div>
        <Header name="ライブ情報の編集" />
        {/* Step11.2.0 TAS-17811 START */}
        <MessageView message={messageWarning} />
        {/* Step11.2.0 TAS-17811 END */}
        <p>編集するライブの内容を指定してください</p>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            this.registerLiveReservation();
          }}
          className='form-horizontal'
        >
          <LiveReservedRegisterInfo
            {...formValues}
            storedUserList={storedUserList}
            showSelectOrganizerDialog={this.showSelectOrganizerDialog}
            showSelectInviteesDialog={this.showSelectInviteesDialog}
            {...liveReservationTime}
            isEdit
            durationDetail={durationLiveDetail}
            removeAllUserFromList={this.removeAllUserFromList}
            onewayLiveEntryLimit={onewayLiveEntryLimit}
            twowayLiveEntryLimit={twowayLiveEntryLimit}
          />
          <LiveRegisterUserList
            {...formValues}
            edittingUsers={edittingUsers}
            removeUserFromList={this.removeUserFromList}
            onewayLiveEntryLimit={onewayLiveEntryLimit}
            twowayLiveEntryLimit={twowayLiveEntryLimit}
          />
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={12} className={this.props.titleClass}>
              <a
                role="presentation"
                className={this.state.expanded ? 'minute' : 'plus'}
                onClick={this.onTitleClick}
              >
                自由記述領域
              </a>
            </Col>
          </Form.Group>
          {this.state.expanded && <LiveUserAttributeEdit />}
          <Form.Group className="form-info">
            <Col sm={12} className="text-center">
              <Button className="btn-96 margin-left-10" onClick={this.goBack}>
                キャンセル
              </Button>
              <Button
                variant="primary"
                className="btn-96 margin-left-10"
                type="submit"
                onClick={this.props.handleSubmit(this.registerLiveReservation)}
              >
                OK
              </Button>
            </Col>
          </Form.Group>
          <ModalConductor
            history={this.props.history}
            singleSelect={this.state.singleSelect}
            addUsersToList={this.addUsersToList}
            withGroup
            parentFormKey="liveReservedRegisterForm"
            headerName={this.state.headerName}
            parentStoreKey="usageSettingLive"
            additionalSearchInfo={additionalSearchInfo}
            shouldAddSearchInfo={this.state.shouldAddSearchInfo}
            userType={this.state.userType}
            maxLength={liveFormat === LIVE_FORMAT_NUM.ONE_WAY ? onewayLiveEntryLimit : twowayLiveEntryLimit}
            isEdit
            withSelectAll
          />
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { liveReservedRegisterForm } = state.form;
  const { storedUserList } = state.user;
  const {
    edittingUsers,
    liveAuthorityIdList,
    liveReservationTime,
    formInitialValues,
    durationLiveDetail,
    onewayLiveEntryLimit,
    twowayLiveEntryLimit,
  } = state.usageSettingLive;
  let initial = formInitialValues;
  const formValues = getFormValues('liveReservedRegisterForm')(state);
  if (formValues && formValues.liveSecernId) {
    initial = formValues;
  }
  const initialValues = {
    ...initial,
  };
  return {
    liveReservedRegisterForm,
    storedUserList,
    edittingUsers,
    liveAuthorityIdList,
    liveReservationTime,
    onewayLiveEntryLimit,
    twowayLiveEntryLimit,
    initialValues,
    invalid: isInvalid('liveReservedRegisterForm')(state),
    formValues,
    durationLiveDetail,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'liveReservedRegisterForm',
    touchOnChange: true,
    enableReinitialize: true,
  })(LiveReservedEditContainer),
);
